import "./locationAdminDetailsEditComponent.scss";
import * as Yup from "yup";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../../../shared/services";
import {IAPIResponseType} from "../../../../../shared/models/api.model";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import Grid from "@mui/material/Grid";
import FormikAutoCompleteDropdown
    from "../../../../../shared/components/core/formik-auto-complete-dropdown/formikAutoCompleteDropdown";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import _ from "lodash";
import commonService from "../../../../../shared/services/common.service";
import LinkComponent from "../../../../../shared/components/link/LinkComponent";
import useRedirectUser from "../../../../../shared/hooks/useRedirectUser";
import FeedbackComponent from "../../../../../shared/components/feedback/feedbackComponent";


interface LocationAdminDetailsEditComponentProps {
    locationDetails: any;
    onUpdateComplete: Function;
    onEditCancel: Function;
}

const validationSchema = Yup.object({
    adminId: Yup.mixed()
    // .required("location admin is required")
});

interface LocationAdminDetailsFormSchema {
    adminId: string;
}

const formInitialValues: LocationAdminDetailsFormSchema = {
    adminId: ''
}


const LocationAdminDetailsEditComponent = (props: LocationAdminDetailsEditComponentProps) => {
    const {onUpdateComplete, onEditCancel, locationDetails} = props;
    const {handleRedirectUserModule} = useRedirectUser();

    const [adminDetailsFormInitialValues, setAdminDetailsFormInitialValues] = useState<LocationAdminDetailsFormSchema>(formInitialValues)
    const [locationAdminsList, setLocationAdminsList] = useState<any>([]);
    const [locationAdminsListLoading, setLocationAdminsListLoading] = useState<boolean>(false);
    const [locationAdminListLoadingFailed, setLocationAdminListLoadingFailed] = useState<boolean>(false);
    const [locationAdminListLoaded, setLocationAdminListLoaded] = useState<boolean>(false);

    const onFormSubmit = useCallback((values: any, {
        setSubmitting,
        setErrors,
    }: FormikHelpers<any>) => {
        const payload = {adminId: values?.adminId?.id || null};
        setSubmitting(true);
        CommonService._location.editLocationDetails(locationDetails?.id, payload)
            .then((response: IAPIResponseType<any>) => {
                setSubmitting(false);
                onUpdateComplete(response?.data);
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                setSubmitting(false);
            })
    }, [locationDetails, onUpdateComplete]);

    const redirectUser = useCallback(() => {
        handleRedirectUserModule({type: 'locationAdmin'})
    }, [handleRedirectUserModule])

    useEffect(() => {
        if (locationDetails?.adminDetails && Object?.keys(locationDetails?.adminDetails)?.length) {
            const adminDetailsObj = _.cloneDeep(locationDetails.adminDetails);
            setAdminDetailsFormInitialValues({adminId: adminDetailsObj});
        }
    }, [locationDetails.adminDetails]);

    const getLocationAdminsList = useCallback(() => {
        setLocationAdminsListLoading(true);
        setLocationAdminListLoaded(false);
        setLocationAdminListLoadingFailed(false)
        commonService._location.getLocationAdminsList({})
            .then((response: IAPIResponseType<any>) => {
                setLocationAdminsList(response.data);
                setLocationAdminListLoaded(true);
                setLocationAdminsListLoading(false);
            })
            .catch((error: any) => {
                setLocationAdminListLoadingFailed(true);
                setLocationAdminsListLoading(false);
            });
    }, [])

    useEffect(() => {
        getLocationAdminsList();
    }, [getLocationAdminsList]);

    return (
        <div className={'admin-details-edit-component details-tab-data-content'}>
            <Formik
                validationSchema={validationSchema}
                initialValues={adminDetailsFormInitialValues}
                validateOnChange={false}
                validateOnBlur={true}
                enableReinitialize={true}
                validateOnMount={true}
                onSubmit={onFormSubmit}
            >
                {({isSubmitting, resetForm, values, dirty, isValid, setFieldValue, validateForm}) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                    }, [validateForm, values]);
                    return (
                        <Form noValidate={true} className={"patient-personal-information-holder"}>
                            <div className={'t-form-controls-wrapper pdd-top-5'}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Field name={'adminId'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikAutoCompleteDropdown
                                                        label={'Location Admin'}
                                                        placeholder={'Select Location Admin'}
                                                        isDataLoaded={locationAdminListLoaded}
                                                        isDataLoading={locationAdminsListLoading}
                                                        isDataLoadingFailed={locationAdminListLoadingFailed}
                                                        // required={true}
                                                        formikField={field}
                                                        data={locationAdminsList}
                                                        valueKey={'id'}
                                                        getOptionLabel={(option => commonService.getFullName(option) || '')}
                                                    />
                                                )
                                            }
                                        </Field>
                                        <div className="redirect-new-link-wrapper">
                                            <div>Didn't find admin?</div>
                                            <LinkComponent className={"redirect-link"}
                                                           onClick={redirectUser}>Create Admin</LinkComponent>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FeedbackComponent className={"mrg-top-10 mrg-bottom-10"}>
                                            Adding an admin is recommended, but if unavailable, it can be skipped
                                            and added later.
                                        </FeedbackComponent>
                                    </Grid>
                                </Grid>
                            </div>
                            <div className={"form-action-section-edit"}>
                                <ButtonComponent
                                    className={"width-25"}
                                    color={"secondary"}
                                    type={"button"}
                                    variant={"outlined"}
                                    disabled={isSubmitting}
                                    handleClick={() => {
                                        onEditCancel();
                                    }}
                                    fullWidth={false}
                                >
                                    Cancel
                                </ButtonComponent>
                                <ButtonComponent
                                    className={"width-25"}
                                    color={"primary"}
                                    type={"submit"}
                                    variant={"contained"}
                                    disabled={!(isValid && dirty)}
                                    fullWidth={false}
                                    isLoading={isSubmitting}
                                >
                                    Save
                                </ButtonComponent>
                            </div>
                        </Form>
                    )
                }
                }
            </Formik>
        </div>
    );

};

export default LocationAdminDetailsEditComponent;
